/* Get eligibility is a subset of buy eligibility in the verified offer. */
(() => {
  const math = {
    quantity(value) { return /^\d+$/.test(String(value)) && Number.isSafeInteger(Number(value)) ? Number(value) : null; },
    capacity(item, lines) {
      if (!item.available) return 0;
      if (item.stock === null) return Infinity;
      return Math.max(0, item.stock - lines.filter(line => String(line.variant_id) === String(item.id)).reduce((n, line) => n + line.quantity, 0));
    },
    offer(lines) {
      const eligible = lines.filter(line => line.buy && !line.subscription);
      const count = eligible.reduce((n, line) => n + line.quantity, 0);
      const candidates = eligible.filter(line => line.get).sort((a, b) => a.price - b.price);
      const getCount = candidates.reduce((n, line) => n + line.quantity, 0);
      const free = Math.min(Math.floor(count / 6), getCount);
      let remaining = free, savings = 0;
      for (const line of candidates) { const q = Math.min(line.quantity, remaining); savings += q * line.price; remaining -= q; }
      const next = Math.max(1, (free + 1) * 6 - count, free + 1 - getCount);
      return {count, free, savings, next, progress: Math.max(0, Math.min(5, 6 - next))};
    },
    group(cart, id) {
      return cart.items.filter(line => line.properties?._tof_box === id).reduce((map, line) => {
        const key = String(line.variant_id); map.set(key, (map.get(key) || 0) + line.quantity); return map;
      }, new Map());
    },
    sameCounts(a, b) { return a.size === b.size && [...a].every(([id, q]) => b.get(id) === q); }
  };
  if (typeof module !== 'undefined' && module.exports) module.exports = math;
  else window.TofBoxMath = Object.freeze(math);
})();
